
  import { WordEdit, WordInterface } from "@/models/words"
  import { defineComponent, nextTick, onActivated, onMounted, onRenderTriggered, onUpdated, Ref, ref, toRefs, watch } from "@vue/runtime-core"

  export default defineComponent({
    name: "WordsList",
    props: {
      words: Object,
      index: Number
    },
    setup(props: any) {
      const itemsInfo: Ref<any[]> = ref([])
      const enItemsInfo: Ref<any[]> = ref([])

      const setWidthText = () => {
        if (itemsInfo.value.length > 1) {
          const len = itemsInfo.value.length - 1
          for (let i = 0; i < len; i++) {
            const text = itemsInfo.value[i].textContent.split("")
            for (let j = 0; j < text.length; j++) {
              if (text[j] === ",") text.splice(j, 1)
            }

            text.push(",")
            itemsInfo.value[i].textContent = text.join("")
          }
        }
        if (itemsInfo.value[0]?.offsetWidth != null && enItemsInfo.value[0]?.offsetWidth != null) {
          if (itemsInfo.value[0].offsetWidth + enItemsInfo.value[0].offsetWidth > 430) {
            const text = itemsInfo.value[0].textContent.split("")
            while (itemsInfo.value[0].offsetWidth + enItemsInfo.value[0].offsetWidth > 430) {
              text.pop()
              itemsInfo.value[0].textContent = text.join("")
            }
            const points = itemsInfo.value[0].textContent.split("")

            points.pop()
            points.pop()
            points.pop()

            points.push("...")
            itemsInfo.value[0].textContent = points.join("")
          }
        }
      }

      nextTick(() => setWidthText())
      onMounted(setWidthText)
      watch(() => props.index, (newValue, oldValue) => setWidthText())

      return { itemsInfo, enItemsInfo }
    },
  })
